import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    activeMenuIndex: '/home',
    productButtons: [],
    newButtons: [],
    scrollButtons: [],
    contact: {
      companyPhone: undefined,
      companyEmail: undefined,
      companyAddress: undefined,
      mapLatitude: undefined,
      mapLongitude: undefined,
    },
    productActiveType: 1,
    newActiveType: 1,
    scrollActiveType: 1,
  },
  mutations: {
    setActiveMenuIndex(state, payload) {
      state.activeMenuIndex = payload;
    },
    setProductActiveType(state, payload) {
      state.productActiveType = payload;
    },
    setNewActiveType(state, payload) {
      state.newActiveType = payload;
    },
    setScrollActiveType(state, payload) {
      state.scrollActiveType = payload;
    },
    setProductButtons(state, payload) {
      state.productButtons = payload;
    },
    setNewButtons(state, payload) {
      state.newButtons = payload;
    },
    setScrollButtons(state, payload) {
      state.scrollButtons = payload;
    },
    setContact(state, payload) {
      state.contact = payload;
    },
  },
});

export default store;
